import graphql__814266535ed89953c8a6 from "./__generated__/ContributionModalEvent_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import { useRoutesContext } from "../../Routes/RoutesContext";
import ButtonLink from "../../Buttons/ButtonLink";
import Icon from "../../Utils/Icon";
import { useFormatMessage } from "../../Intl/Context";
import { useFormatEventDate } from "../../Events/formatEventDate";

const ContributionModalEvent = props => {
  const contribution = useFragment(
    ContributionModalEvent_contribution,
    props.contribution
  );

  const { events } = contribution;

  const { pathFor } = useRoutesContext();

  const t = useFormatMessage();
  const seeLinkedEvent = t(intlMessages.seeLinkedEvent);

  const formatEventDate = useFormatEventDate();

  // Don't display the block if there's no event associated to the contribution
  if (!events.length) return null;

  const event = events[0];
  const { title, slug: participativeModuleSlug, visualization } = event;
  const eventUrl = pathFor("participativeModule", { participativeModuleSlug });

  const formattedDate = formatEventDate(visualization.startsAt);

  return (
    <div className="box event margin-top-xs">
      <div className="title margin-bottom-xs d-flex align-items-center">
        <Icon className="icon-calendar align-middle margin-right-xs bg-primary padding-xs rounded-circle" />
        {title}
      </div>

      <div className="d-flex align-items-center margin-bottom-xs">
        <Icon className="icon-time margin-right-xxs text-primary" />
        {formattedDate}
      </div>

      <ButtonLink
        href={eventUrl}
        className="btn btn-block-sm btn-primary"
        label={seeLinkedEvent}
        iconClassName="icon-arrow-right"
        iconPosition="after"
      />
    </div>
  );
};

const ContributionModalEvent_contribution = graphql__814266535ed89953c8a6;

export default ContributionModalEvent;

const intlMessages = defineMessages({
  seeLinkedEvent: {
    id: "contributions.modal.seeLinkedEvent",
    defaultMessage: "Voir l'évènement lié"
  }
});
